export interface CustomError extends Error {
  retmsg: string;
  retcode: string;
  code: number;
}

export function to<T>(promise: Promise<T>): Promise<[null, T] | [CustomError, T]> {
  return promise.then(data => [null, data] as [null, T])
    .catch(err => [err, null] as [CustomError, unknown] as [CustomError, T]);
}
